import {
  fetcTableData,
  fetchChartData,
  fetchLocationData
} from "../../api/uzgidromet";

export default {
  FETCH_TABLE_DATA({ commit }, a) {
    return new Promise((resolve, reject) => {
      fetcTableData(a)
        .then(res => {
          commit("SET_TABLE_DATA", res.data);
          resolve(res);
        })
        .catch(reject);
    });
  },
  FETCH_CHART_DATA({ commit }, a) {
    return new Promise((resolve, reject) => {
      fetchChartData(a)
        .then(res => {
          commit("SET_CHART_DATA", res.data);
          resolve(res);
        })
        .catch(reject);
    });
  },
  FETCH_LOCATION_DATA({ commit }, a) {
    return new Promise((resolve, reject) => {
      fetchLocationData(a)
        .then(resolve)
        .catch(reject);
    });
  }
};
